
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"height":"512pt","viewBox":"0 0 512 512.923","width":"512pt","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M433.348 512.922H80.449A80 80 0 018.9 397.164L185.331 44.25C198.875 17.133 226.586 0 256.898 0s58.024 17.133 71.567 44.25l176.433 352.914a80 80 0 01-71.55 115.758zm0 0","fill":"#ff7761"}}),_c('g',{attrs:{"fill":"#fff"}},[_c('path',{attrs:{"d":"M256.898 128.203c8.836 0 16 7.164 16 16v192c0 8.836-7.164 16-16 16s-16-7.164-16-16v-192c0-8.836 7.165-16 16-16zm0 0M240.898 384.203h32v32h-32zm0 0"}})])])
          )
        }
      }
    